const CAMPUS_CANONICAL = {
  mistlaalali: 'tlaAlAli',
  miskhalda: 'khalda',
}

function normalizeCampusKey(campus) {
  if (!campus) return null

  const compact = campus.toLowerCase().replace(/[^a-z0-9]/g, '')
  if (CAMPUS_CANONICAL[compact]) {
    return CAMPUS_CANONICAL[compact]
  }

  if (campus === 'MisTlaAlAli' || campus === 'tlaAlAli') return 'tlaAlAli'
  if (campus === 'MisKhalda' || campus === 'khalda') return 'khalda'

  return null
}

export function formatCampusLabel(campus, t) {
  if (!campus) return '—'

  const key = normalizeCampusKey(campus)
  if (key) {
    const label = t(`admin.applications.campusNames.${key}`)
    if (label !== `admin.applications.campusNames.${key}`) return label
  }

  return campus
}
